// Breakpoint reference values. The widget mobile split is lower than the
// generic tablet split so the 626px Figma web iframe stays in web layout.
export const BREAKPOINTS = {
  mobile: 375,
  widgetMobile: 600,
  tablet: 768,
  desktop: 1024,
} as const;

// Primary split point used by useBreakpoint.
export const MOBILE_MAX_WIDTH = 599; // < 600 => mobile

// Layout dimensions (mirrors tokens.less for use in TS/chart sizing).
export const LAYOUT = {
  desktopContentWidth: 626,
  mobileViewportWidth: 375,
  mobileContentWidth: 343,
  mobileSidePadding: 16,
} as const;
